import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getStatusChipSx, getStatusLabel } from 'common/utils/sessionColor';

/**
 * Chip de estado de sesión con color semáforo (azul/verde/rojo/ámbar). SOLO para vistas
 * de sesión; los tokens son mode-aware (palette.sessionStatus).
 */
function SessionStatusChip({ status, startDate = null, size = 'small' }) {
  const theme = useTheme();
  const { t } = useTranslation(['sessions']);

  return (
    <Chip
      label={getStatusLabel(t, status, startDate)}
      size={size}
      sx={getStatusChipSx(theme, status, startDate)}
    />
  );
}

SessionStatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  size: PropTypes.string
};

export default SessionStatusChip;
